module.exports = __webpack_public_path__ + "assets/img/travel-share.3de209f7.png";